
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'CardComponent',
    props: {
        img: String,
        altImg: String,
        title: String,
        description: String,
        value: Number,
        currency: String,
        time: Number,
        timeRemaining: String,
        creator: String,
        creatorLink: String,
        avatar: String,
        avatarAlt: String,
        viewImg: String,
        viewAlt: String,
    },
})
